function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.32643 0.166626L0 9.12932H9.16817L5.0294 23.0027L26.8857 9.12932H18.0384L20.4565 0.166626H2.32643Z",
    fill: "url(#paint0_linear_2_4139)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4416 0.166626H24.1794L21.8817 9.12932H18.0234L20.4416 0.166626Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8833 9.1236H34.17L5.02393 22.9969L26.8833 9.1236Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4139",
    x1: 13.4428,
    y1: 0.166626,
    x2: 13.4428,
    y2: 18.5392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB83",
    style: {
      stopColor: "#FFEB83",
      stopColor: "color(display-p3 1.0000 0.9216 0.5137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247213,
    stopColor: "#FFBF83",
    style: {
      stopColor: "#FFBF83",
      stopColor: "color(display-p3 1.0000 0.7490 0.5137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682213,
    stopColor: "#E677E9",
    style: {
      stopColor: "#E677E9",
      stopColor: "color(display-p3 0.9031 0.4685 0.9120)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B283FF",
    style: {
      stopColor: "#B283FF",
      stopColor: "color(display-p3 0.6985 0.5137 1.0000)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeusLogo);
export default __webpack_public_path__ + "static/media/zeus-logo.48e3ba951ad9a9550f140b234e8c66c1.svg";
export { ForwardRef as ReactComponent };